<div class="mt-2">
  <ng-container *ngTemplateOutlet="grid; context: { type: type }"></ng-container>
</div>

<ng-template #grid let-type="type">
  <dx-data-grid
    #dataGridRef
    *var="inEditMode$ | async as inEditMode"
    class="socials-grid__data-grid"
    [class.ag-profile-grid__grid]="LayoutGridType.default !== type"
    [class.socials-grid__data-grid--view]="!inEditMode"
    [dataSource]="socials"
    [showRowLines]="LayoutGridType.default === type"
    [showBorders]="LayoutGridType.default === type"
    [showColumnLines]="LayoutGridType.default === type"
    [showColumnHeaders]="LayoutGridType.default === type"
    [columnAutoWidth]="true"
    [wordWrapEnabled]="true"
    [rowAlternationEnabled]="false"
    [noDataText]="emptyMessage"
    [selectedRowKeys]="selectedRowKeys"
    (selectedRowKeysChange)="selectedRowKeysChange.emit($event)"
    (onInitNewRow)="onInitNewRow($event)"
    (onRowRemoving)="onRowRemoving($event)"
    height="100%"
  >
    <dxo-toolbar>
      <dxi-item location="before">
        <div *dxTemplate>
          <div class="toolbar-label">
            <b>{{ gridTitle }}</b>
          </div>
        </div>
      </dxi-item>

      @if (hasPermissionsToEdit) {
        <dxi-item
          [visible]="!inEditMode"
          location="after"
          widget="dxButton"
          locateInMenu="auto"
          [cssClass]="'ag-profile-grid__toolbar-button'"
        >
          <div *dxTemplate>
            <dx-button
              hint="ENABLE EDIT"
              icon="edit"
              stylingMode="text"
              [agMergeGuard]="agentDbId"
              (agMergeGuardedClick)="enableEditMode()"
            ></dx-button>
          </div>
        </dxi-item>

        <dxi-item
          [visible]="inEditMode"
          location="after"
          widget="dxButton"
          locateInMenu="auto"
          [cssClass]="'ag-profile-grid__toolbar-button'"
        >
          <div *dxTemplate>
            <dx-button
              hint="CANCEL EDIT"
              icon="undo"
              type="danger"
              stylingMode="text"
              (onClick)="disableEditMode()"
            ></dx-button>
          </div>
        </dxi-item>
      }

      @if (inEditMode && hasPermissionsToAdd) {
        <dxi-item
          location="after"
          widget="dxButton"
          [cssClass]="type !== LayoutGridType.default ? 'ag-profile-grid__toolbar-button' : ''"
        >
          <div *dxTemplate>
            <dx-button
              icon="plus"
              [stylingMode]="type !== LayoutGridType.default ? 'text' : 'outlined'"
              [agMergeGuard]="agentDbId"
              (agMergeGuardedClick)="handleEditSocials($event)"
            ></dx-button>
          </div>
        </dxi-item>
      }
    </dxo-toolbar>

    <dxo-editing
      mode="row"
      [useIcons]="true"
      [allowUpdating]="hasPermissionsToEdit"
      [allowDeleting]="hasPermissionsToDelete"
      [allowAdding]="hasPermissionsToAdd"
    >
    </dxo-editing>

    <dxo-selection [selectAllMode]="'allPages'" [showCheckBoxesMode]="'always'" [mode]="selectionMode"></dxo-selection>

    <dxo-paging [enabled]="false"></dxo-paging>
    <dxo-scrolling [mode]="'virtual'" [showScrollbar]="'always'"></dxo-scrolling>

    <dxi-column
      [visible]="LayoutGridType.default !== type"
      [name]="'fullUrlAddress'"
      [caption]="''"
      cellTemplate="fullSocialCellTemplate"
      [width]="LayoutGridType.short === type ? '80%' : '50%'"
    >
      <div *dxTemplate="let cell of 'fullSocialCellTemplate'" class="ag-profile-grid__text-with-icons">
        <dx-button
          *var="cell?.data?.[SocialKeys.url] as url"
          [elementAttr]="{ class: 'ag-profile-grid__button-link' }"
          [icon]="cell?.data?.[SocialKeys.socialMedia] | socialIcon"
          [text]="cell?.data | socialNameFromUrl"
          [hint]="url"
          [type]="'default'"
          [stylingMode]="'text'"
          (onClick)="gotoSocial(url)"
        ></dx-button>
      </div>
    </dxi-column>

    <dxi-column [dataField]="SocialKeys.url" [width]="'50%'" [visible]="LayoutGridType.default === type"></dxi-column>

    <dxi-column
      [dataField]="SocialKeys.socialType"
      [caption]="'Type'"
      [editorOptions]="{ onSelectionChanged: onSocialTypeChanged }"
      cellTemplate="fullSocialTypeCellTemplate"
    >
      <dxo-lookup
        [dataSource]="socialTypesLookup"
        [displayExpr]="LookupKeys.description"
        [valueExpr]="BaseModelKeys.dbId"
      ></dxo-lookup>
      <div *dxTemplate="let cell of 'fullSocialTypeCellTemplate'" class="ag-profile-grid__text-with-icons">
        <i
          class="dx-icon ag-profile-grid__list-icon"
          [ngClass]="cell?.displayValue | businessPersonalTypeIcon"
          [title]="cell?.displayValue"
        ></i>
      </div>
    </dxi-column>

    <dxi-column
      [visible]="LayoutGridType.default === type"
      [dataField]="SocialKeys.socialMedia"
      [caption]="'Social Media'"
      [editorOptions]="{ onSelectionChanged: onSocialMediaChanged }"
    >
      <dxo-lookup
        [dataSource]="socialMediaLookup"
        [displayExpr]="LookupKeys.description"
        [valueExpr]="BaseModelKeys.dbId"
      ></dxo-lookup>
    </dxi-column>

    <dxi-column type="buttons" [visible]="inEditMode" [width]="LayoutGridType.default !== type ? '60px' : undefined">
      <dxi-button icon="edit" [cssClass]="'ag-profile-grid__col-button'" [visible]="hasPermissionsToEdit" [onClick]="handleEditSocials"></dxi-button>
      <dxi-button name="delete" icon="trash" [cssClass]="'ag-profile-grid__col-button'"></dxi-button>
    </dxi-column>
  </dx-data-grid>
</ng-template>

<ag-shr-modal-window
  #socialsEditorModalRef
  [title]="socialsModalTitle"
  [inProgress]="inProgress$ | async"
  (onSaveClick)="handleSocialMediaSave($event)"
  [onCloseModal]="handleSocialMediaClosePopup"
  [width]="'50vw'"
  [height]="'auto'"
  [extraToolbarItems]="[
    {
      widget: 'dxButton',
      location: 'before',
      toolbar: 'bottom',
      options: {
        text: 'VALIDATE ACCOUNT',
        onClick: onValidateAccountClick,
        disabled: !socialFormComponent?.formData[SocialKeys.url],
        elementAttr: {
          class: 'modal-window__toolbar-button',
        },
      },
    },
  ]"
>
  <ng-container *ngIf="socialsEditorModalRef?.popupComponent?.visible ?? false">
    <ag-shr-social-form
      #socialFormRef
      [social]="socialToEdit"
      [socialMediaLookup]="socialMediaLookup"
      [socialTypesLookup]="socialTypesLookup"
      [validationGroup]="socialValidationGroup"
    ></ag-shr-social-form>
  </ng-container>
</ag-shr-modal-window>
